import { SettingsConfigTypes } from "./types/settings-config-types";

export const SettingsConfig: SettingsConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
